import React, { Suspense, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { Helmet } from "react-helmet";
import { useMediaQuery } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Loader from "../../Loader";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Navigation, Pagination, Autoplay } from "swiper";
import { Button, Spinner } from "react-bootstrap";

import LoaderInternal from "../../LoaderInternal";
import { Link, useNavigate, useParams } from "react-router-dom";
import { fetchRoomBooking } from "../../data/juniper-hotels/roomBookingSlice";
import { Splide, SplideSlide } from "@splidejs/react-splide";
import "@splidejs/splide/dist/css/splide.min.css";
import BookingStepThree from "../../components/booking-steps/BookingStepThree";
import { fetchReviewBooking } from "../../data/juniper-hotels/reviewBookingSlice";
SwiperCore.use([Navigation, Pagination, Autoplay]);
const RoomDetails = () => {
  const { txt_var_HotelName } = useParams();
  const { var_HotelAddress } = useParams();
  const RatePlanCode = localStorage.getItem("RatePlanCode");
  const { var_HotelJPCode } = useParams();
  // will use this > RatePlanCode
  const decodedHotelName = decodeURIComponent(txt_var_HotelName);
  const decodedHotelAddress = decodeURIComponent(var_HotelAddress);

  const currency = useSelector((state) => state.currency.currency);
  const [extraChecked, setExtraChecked] = useState(false);
  const [checkedValues, setCheckedValues] = useState([]);
  const [showMore, setShowMore] = useState(false);

  const handleCheckboxChange = (id) => {
    setCheckedValues((prevState) => {
      if (prevState.includes(id)) {
        // Remove id from the array if it's already present
        return prevState.filter((item) => item !== id);
      } else {
        // Add id to the array if it's not present
        return [...prevState, id];
      }
    });
  };

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const isMobile = useMediaQuery("(max-width:767px)");
  const isTablet = useMediaQuery("(max-width:1024px)");
  const { roomBooking, loading, error } = useSelector(
    (state) => state.roomBooking
  );
  // const destinationIdLocalStorage = localStorage.getItem("destinationId");
  const nationalityLocalStorage = localStorage.getItem("nationality");
  const startDateHotelsLocalStorage = new Date(
    localStorage.getItem("startDateHotels")
  );
  const endDateHotelsLocalStorage = new Date(
    localStorage.getItem("endDateHotels")
  );
  const roomsHotelsLocalStorage = localStorage.getItem("roomsHotels");
  const adultsHotels1RLocalStorage = localStorage.getItem("adultsHotels1R");
  const adultsHotels2RLocalStorage = localStorage.getItem("adultsHotels2R");
  const adultsHotels3RLocalStorage = localStorage.getItem("adultsHotels3R");
  const totalAdults =
    Number(adultsHotels1RLocalStorage) +
    Number(adultsHotels2RLocalStorage) +
    Number(adultsHotels3RLocalStorage);
  const childrenHotels1RLocalStorage = localStorage.getItem("childrenHotels1R");
  const childrenAge1R1LocalStorage = localStorage.getItem("childrenAge1R1");
  const childrenAge1R2LocalStorage = localStorage.getItem("childrenAge1R2");
  const childrenHotels2RLocalStorage = localStorage.getItem("childrenHotels2R");
  const childrenAge2R1LocalStorage = localStorage.getItem("childrenAge2R1");
  const childrenAge2R2LocalStorage = localStorage.getItem("childrenAge2R2");
  const childrenHotels3RLocalStorage = localStorage.getItem("childrenHotels3R");
  const childrenAge3R1LocalStorage = localStorage.getItem("childrenAge3R1");
  const childrenAge3R2LocalStorage = localStorage.getItem("childrenAge3R2");
  const totalChildren =
    Number(childrenHotels1RLocalStorage) +
    Number(childrenHotels2RLocalStorage) +
    Number(childrenHotels3RLocalStorage);
  useEffect(() => {
    const roomData = {
      // txt_var_RoomNet: 91,
      // txt_var_RoomName: "",
      // txt_var_RoomCategoryName: "",
      txt_var_NumRooms: roomsHotelsLocalStorage,

      // txt_var_RoomBoardName: "",
      // txt_var_RoomBoardCode: "",
      // txt_var_RoomGross: 91,
      // txt_var_RoomServices: 91,
      // txt_var_RoomServicesTax: 91,
      txt_var_RoomRatePlanCode: RatePlanCode,

      // "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",
      txt_var_RoomCurrency: currency,
      txt_var_HotelName: decodedHotelName,

      txt_var_HotelJPCode: var_HotelJPCode,

      // txt_var_HotelCategory: "5 Stars",
      txt_var_HotelAddress: decodedHotelAddress,

      //   "Isis Island, Corniche El Nil, Aswan , 1234, Corniche Aswan ,  Aswan ,  Aswan Governorate  ,  Egypt",
      txt_var_HotelChain: "",
      txt_var_R1ANo: adultsHotels1RLocalStorage,
      txt_var_R1CNo: childrenHotels1RLocalStorage,
      txt_var_R1CA1: childrenAge1R1LocalStorage,
      txt_var_R1CA2: childrenAge1R2LocalStorage,
      txt_var_R2ANo: adultsHotels2RLocalStorage,
      txt_var_R2CNo: childrenHotels2RLocalStorage,
      txt_var_R2CA1: childrenAge2R1LocalStorage,
      txt_var_R2CA2: childrenAge1R2LocalStorage,
      txt_var_R3ANo: adultsHotels3RLocalStorage,
      txt_var_R3CNo: childrenHotels3RLocalStorage,
      txt_var_R3CA1: childrenAge3R1LocalStorage,
      txt_var_R3CA2: childrenAge1R2LocalStorage,

      txt_var_StartDate: startDateHotelsLocalStorage
        .toISOString()
        .split("T")[0],

      txt_var_EndDate: endDateHotelsLocalStorage.toISOString().split("T")[0],
      currency: currency,
    };

    dispatch(fetchRoomBooking(roomData));
  }, [dispatch, currency]);
  const { reviewBooking, loadingReview, errorReview, isErrorReview } =
    useSelector((state) => state.reviewBooking);
  //  Adults
  const [inputValues, setInputValues] = useState(
    Array.from({ length: totalAdults }, () => ({
      firstName: "",
      lastName: "",
      email: "",
      mobile: "",
    }))
  );
  const handleInputChange = (index, field, value) => {
    const newInputValues = [...inputValues];
    newInputValues[index][field] = value;
    setInputValues(newInputValues);
  };
  // Childereen
  const [childInputValues, setChildInputValues] = useState(
    Array.from({ length: totalChildren }, () => ({
      firstName: "",
      lastName: "",
    }))
  );
  const handleChildInputChange = (index, field, value) => {
    const newChildInputValues = [...childInputValues];
    newChildInputValues[index][field] = value;
    setChildInputValues(newChildInputValues);
  };
  // Message
  const [specialRequest, setSpecialRequest] = useState("");

  const handleBookingReview = (e) => {
    e.preventDefault();
    const cstData = {
      txt_var_RoomRatePlanCode: RatePlanCode,
      CKItems: checkedValues,
      txt_Adult_Mobile: inputValues[0]?.mobile || "",
      txt_Adult_FirstName: inputValues[0]?.firstName || "",
      txt_Adult_LastName: inputValues[0]?.lastName || "",
      txt_Adult_Nationality: nationalityLocalStorage,
      txt_Adult_Email: inputValues[0]?.email || "",
      txt_var_HotelJPCode: var_HotelJPCode,
      txt_var_R1ANo: adultsHotels1RLocalStorage,
      txt_var_R1CNo: childrenHotels1RLocalStorage,
      txt_var_R1CA1: childrenAge1R1LocalStorage,
      txt_var_R1CA2: childrenAge1R2LocalStorage,
      txt_var_R2ANo:
        roomsHotelsLocalStorage == 2 ? adultsHotels2RLocalStorage : "0",
      txt_var_R2CNo: childrenHotels2RLocalStorage,
      txt_var_R2CA1: childrenAge2R1LocalStorage,
      txt_var_R2CA2: childrenAge2R2LocalStorage,
      txt_var_R3ANo:
        roomsHotelsLocalStorage == 3 ? adultsHotels3RLocalStorage : "0",
      txt_var_R3CNo: childrenHotels3RLocalStorage,
      txt_var_R3CA1: childrenAge3R1LocalStorage,
      txt_var_R3CA2: childrenAge3R2LocalStorage,
      txt_var_StartDate: startDateHotelsLocalStorage
        .toISOString()
        .split("T")[0],
      txt_var_EndDate: endDateHotelsLocalStorage.toISOString().split("T")[0],
      txt_var_NumRooms: roomsHotelsLocalStorage,
      txt_var_AdultInRooms: totalAdults,
      txt_var_ChildInRooms: totalChildren,
      txt_Adult_FirstName_0: inputValues[0]?.firstName || "",
      txt_Adult_LastName_0: inputValues[0]?.lastName || "",
      txt_Adult_FirstName_1: inputValues[1]?.firstName || "",
      txt_Adult_LastName_1: inputValues[1]?.lastName || "",
      txt_Adult_FirstName_2: inputValues[2]?.firstName || "",
      txt_Adult_LastName_2: inputValues[2]?.lastName || "",
      txt_Adult_FirstName_3: inputValues[3]?.firstName || "",
      txt_Adult_LastName_3: inputValues[3]?.lastName || "",
      txt_Adult_FirstName_4: inputValues[4]?.firstName || "",
      txt_Adult_LastName_4: inputValues[4]?.lastName || "",
      txt_Adult_FirstName_5: inputValues[5]?.firstName || "",
      txt_Adult_LastName_5: inputValues[5]?.lastName || "",
      txt_Adult_FirstName_6: inputValues[6]?.firstName || "",
      txt_Adult_LastName_6: inputValues[6]?.lastName || "",
      txt_Adult_FirstName_7: inputValues[7]?.firstName || "",
      txt_Adult_LastName_7: inputValues[7]?.lastName || "",
      txt_Adult_FirstName_8: inputValues[8]?.firstName || "",
      txt_Adult_LastName_8: inputValues[8]?.lastName || "",
      txt_Child_FirstName_0: childInputValues[0]?.firstName || "",
      txt_Child_LastName_0: childInputValues[0]?.lastName || "",
      txt_Child_FirstName_1: childInputValues[1]?.firstName || "",
      txt_Child_LastName_1: childInputValues[1]?.lastName || "",
      txt_Child_FirstName_2: childInputValues[2]?.firstName || "",
      txt_Child_LastName_2: childInputValues[2]?.lastName || "",
      txt_Child_FirstName_3: childInputValues[3]?.firstName || "",
      txt_Child_LastName_3: childInputValues[3]?.lastName || "",
      txt_Child_FirstName_4: childInputValues[4]?.firstName || "",
      txt_Child_LastName_4: childInputValues[4]?.lastName || "",
      txt_Child_FirstName_5: childInputValues[5]?.firstName || "",
      txt_Child_LastName_5: childInputValues[5]?.lastName || "",
      txt_SpecialRequest: specialRequest,
      txt_RoomName_1: roomBooking.DetailsBookingResults?.RoomList[0]
        ?.var_RoomName
        ? roomBooking.DetailsBookingResults?.RoomList[0]?.var_RoomName
        : "",
      txt_RoomName_2: roomBooking.DetailsBookingResults?.RoomList[1]
        ?.var_RoomName
        ? roomBooking.DetailsBookingResults?.RoomList[1]?.var_RoomName
        : "",
      txt_RoomName_3: roomBooking.DetailsBookingResults?.RoomList[2]
        ?.var_RoomName
        ? roomBooking.DetailsBookingResults?.RoomList[2]?.var_RoomName
        : "",
    };
    dispatch(fetchReviewBooking(cstData));
  };
  useEffect(() => {
    if (!loadingReview && !isErrorReview && reviewBooking?.BookingId) {
      navigate(`/HotelBookingReview/${reviewBooking.BookingId}`);
    }
  }, [loadingReview, isErrorReview, reviewBooking, navigate]);
  // slider

  const [mainSplide, setMainSplide] = useState(null);
  const [thumbnailSplide, setThumbnailSplide] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(1);
  const [totalSlides, setTotalSlides] = useState(
    roomBooking.ListHotelPhotos?.length
  );

  useEffect(() => {
    if (mainSplide && thumbnailSplide) {
      // Update main carousel when a thumbnail is clicked
      thumbnailSplide.on("click", (slide) => {
        const index = slide.index;
        mainSplide.go(index); // Synchronize main carousel with thumbnail click
      });

      // Update currentIndex and totalSlides on main carousel change
      mainSplide.on("moved", () => {
        const index = mainSplide.index;
        setCurrentIndex(index + 1); // Splide uses zero-based index
        setTotalSlides(mainSplide.length);
      });
    }
  }, [mainSplide, thumbnailSplide]);
  // Effect to initialize Splide instances and synchronize them
  useEffect(() => {
    if (mainSplide && thumbnailSplide) {
      // Update main carousel when a thumbnail is clicked
      thumbnailSplide.on("click", (slide) => {
        const index = slide.index;
        mainSplide.go(index); // Synchronize main carousel with thumbnail click
      });
    }
  }, [loading, mainSplide, thumbnailSplide]);

  // Main carousel options
  const mainOptions = {
    type: "loop",
    perPage: 1,
    pagination: false,
    height: isMobile ? "50" : "75vh",
    drag: true,
    gap: 10,
    updateOnMove: true,
  };

  // Thumbnail carousel options
  const thumbnailOptions = {
    fixedWidth: 180,
    fixedHeight: 122,
    isNavigation: false,
    focus: "center",
    pagination: false,
    direction: "ttb",
    height: "75vh",
    gap: 10,
  };

  // Format the date in the desired format
  const formatDate = (dateString) => {
    if (!dateString) return null;

    // Convert date string to JavaScript Date object
    const date = new Date(dateString);

    // Check if the date is valid
    if (isNaN(date.getTime())) return dateString;

    // Format the date in the desired format
    const formattedDate = date.toLocaleDateString("en-US", {
      weekday: "long",
      year: "numeric",
      month: "long",
      day: "numeric",
    });

    return formattedDate;
  };
  const unescapeHtml = (html) => {
    const textArea = document.createElement("textarea");
    textArea.innerHTML = html;
    return textArea.value;
  };

  return (
    <>
      {loading ? (
        <Loader />
      ) : error ? (
        <section
          style={{ backgroundColor: "#e60000", padding: "200px 0 100px" }}
        >
          <h1 className="text-center text-light">{error}</h1>
        </section>
      ) : (
        <>
          <Helmet>
            <title>{roomBooking.PageDetails?.PageMetatagTitle}</title>
            <meta
              name="description"
              content={roomBooking.PageDetails?.PageMetatagDescription}
            />
            <link
              href="TITSolutions/WS/assets/hotelsAvailability.css"
              rel="stylesheet"
              type="text/css"
            />{" "}
            <link
              href="TITSolutions/WS/assets/hotel-form.css"
              rel="stylesheet"
              type="text/css"
            />
          </Helmet>
          {!roomBooking.PageDetails?.PageTitle &&
          !roomBooking.ListHotelPhotos &&
          !roomBooking?.DetailsBookingResults?.var_HotelDescription ? (
            <section
              style={{
                backgroundColor: "#e60000",
                padding: "200px 0 100px",
                textAlign: "center",
              }}
            >
              <h1 className="text-center text-light">
                No Data Available For This Room
              </h1>
              <Button
                onClick={() => navigate(-1)}
                className="btn btn-bg-light mt-3"
                style={{ border: "1px solid #fff" }}
              >
                {" "}
                Choose Another Room{" "}
              </Button>
            </section>
          ) : (
            <>
              <aside className="rlr-hero--half-mast ">
                <div className="outter">
                  <div
                    id="rlr_banner_slider"
                    className="splide rlr-banner-splide rlr-banner-splide--fullwidth-v2"
                  >
                    <div className="splide__track rlr-banner-splide__track">
                      <ul className="splide__list height-internal-pages">
                        <li className="splide__slide height-internal-pages rlr-banner-splide__slide">
                          <div className="rlr-banner-splide__image-wrapper height-internal-pages">
                            <div className="overlay-banner"></div>
                            <Suspense fallback={<div>Loading...</div>}>
                              <img
                                className="rlr-banner-splide__banner-img"
                                src={
                                  isMobile
                                    ? `images/uploads/1.jpg`
                                    : isTablet
                                    ? `images/uploads/2.jpg`
                                    : `images/uploads/Banner-Hotel-Booking.jpg`
                                }
                                alt={
                                  roomBooking.PageDetails?.PageTitle || "Hotels"
                                }
                                loading="lazy"
                              />
                            </Suspense>
                          </div>
                          <article className="rlr-banner-splide__content-wrapper container">
                            <div className="row justify-content-start">
                              <div className="col-xl-9">
                                <div className="rlr-banner-splide__header">
                                  <h2
                                    className="rlr-banner-splide__slogan rlr-section__title--main"
                                    style={{ textShadow: "1px 1px 2px #000" }}
                                  >
                                    {roomBooking.PageDetails?.PageTitle ||
                                      "Hotels"}
                                  </h2>
                                </div>
                              </div>
                            </div>
                          </article>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </aside>
              <BookingStepThree />
              <section>
                <div className="container">
                  <div
                    className="rlr-product-detail-header mt-100 col-lg-10"
                    id="rlr-js-detail-header"
                  >
                    <div className="rlr-product-detail-header__contents">
                      <h1 className="rlr-section__heading--main rlr-product-detail-header__title rlr-section__title--main mb-0">
                        {roomBooking.PageDetails?.PageTitle}
                      </h1>
                      <div
                        className="rlr-review-stars d-flex align-items-baseline"
                        itemScope
                        itemType="https://schema.org/Product"
                      >
                        <div>
                          <p>
                            <i className="flaticon-carbon-location mr-1"></i>{" "}
                            {decodedHotelAddress}
                          </p>
                        </div>
                        <div
                          className="rlr-review-stars ms-3"
                          itemProp="ratingValue"
                          itemScope
                          itemType="https://schema.org/Product"
                        >
                          <i className="rlr-icon-font flaticon-star-1"></i>
                          <i className="rlr-icon-font flaticon-star-1"></i>
                          <i className="rlr-icon-font flaticon-star-1"></i>
                          <i className="rlr-icon-font flaticon-star-1"></i>
                          <i className="rlr-icon-font flaticon-star-1"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                  {roomBooking.ListHotelPhotos?.length > 0 && (
                    <div className="row  justify-content-between">
                      <div className="col-12 col-md-10 m-auto position-relative">
                        <Splide options={mainOptions} onMounted={setMainSplide}>
                          {roomBooking.ListHotelPhotos?.map((image, index) => (
                            <>
                              {" "}
                              <SplideSlide
                                key={index}
                                className="d-flex justify-content-center align-items-center"
                              >
                                <img
                                  src={image.PhotoURL}
                                  alt={`Slide ${index}`}
                                  loading="lazy"
                                  style={{
                                    width: "auto",
                                    height: "auto",
                                    borderRadius: ".5rem",
                                  }}
                                />
                                <div className="rlr-media__custom-pagination rlr-js-custom-pagination">
                                  <svg
                                    width="18"
                                    height="14"
                                    viewBox="0 0 18 14"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M1.2 0C.542 0 0 .558 0 1.235v11.53C0 13.442.542 14 1.2 14h15.6c.658 0 1.2-.558 1.2-1.235V1.235C18 .558 17.458 0 16.8 0H1.2zm0 .824h15.6c.228 0 .4.176.4.411v9.844l-3.506-3.95a.4.4 0 0 0-.588 0l-2.862 3.126L6.1 5.488a.4.4 0 0 0-.362-.135.4.4 0 0 0-.232.129L.8 10.687V1.235C.8 1 .972.823 1.2.823zm9.2 2.058c-.879 0-1.6.743-1.6 1.647 0 .905.721 1.647 1.6 1.647.879 0 1.6-.742 1.6-1.647 0-.904-.721-1.647-1.6-1.647zm0 .824c.447 0 .8.363.8.823 0 .46-.353.824-.8.824a.806.806 0 0 1-.8-.824c0-.46.353-.823.8-.823zm-4.606 2.67 5.912 6.8H1.2a.397.397 0 0 1-.4-.411v-.869l4.994-5.52zm7.6 1.64 3.806 4.285v.464a.397.397 0 0 1-.4.411h-4.019l-2-2.303 2.613-2.856z"
                                      fill="#212529"
                                    ></path>
                                  </svg>
                                  <span className="rlr-media__page-counter rlr-js-page">
                                    {index + 1} /{" "}
                                    {roomBooking.ListHotelPhotos?.length}
                                  </span>
                                </div>
                              </SplideSlide>
                            </>
                          ))}
                        </Splide>{" "}
                      </div>
                      {!isMobile && (
                        <div className="col-md-2">
                          <Splide
                            options={thumbnailOptions}
                            onMounted={setThumbnailSplide}
                          >
                            {roomBooking.ListHotelPhotos?.map(
                              (image, index) => (
                                <SplideSlide key={index}>
                                  <img
                                    src={image.PhotoURL}
                                    alt={`Thumbnail ${index}`}
                                    style={{
                                      width: "100%",
                                      height: "122px",
                                      cursor: "pointer",
                                      borderRadius: ".5rem",
                                    }}
                                  />
                                </SplideSlide>
                              )
                            )}
                          </Splide>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </section>
              <section className=" rlr-product-detail-section">
                <div className="container">
                  {" "}
                  <div className="row">
                    <aside className="col-xl-4 col-xxxl-3 d-xl-block offset-xxxl-1 mt-5 mt-lg-0">
                      <div className="mb-4">
                        <div className="border border-color-7 rounded mb-5">
                          <div className="border-bottom">
                            <div className="p-4">
                              <span className="font-size-22 fs-3">
                                Booking Details
                              </span>
                            </div>
                          </div>
                          <form action="/en/hotels-booking" className="p-4">
                            <span className="d-block text-gray-1 font-weight-bold mb-2 text-left">
                              Destination
                            </span>
                            <div className="mb-4">
                              <div className="input-group border-bottom border-width-2 border-color-1 d-flex align-items-baseline">
                                <i className="fa-mytravel-pin-1 mr-2 text-primary font-weight-semi-bold font-size-22"></i>
                                <p className="w-80">{decodedHotelAddress}</p>
                              </div>
                            </div>
                            <span className="d-block text-gray-1 font-weight-bold mb-2 text-left">
                              Hotel
                            </span>
                            <div className="mb-4">
                              <div className="input-group border-bottom border-width-2 border-color-1 d-flex align-items-baseline">
                                <i className="fa-mytravel-hotel mr-2 text-primary font-weight-semi-bold font-size-22"></i>
                                <p className="w-80">
                                  {
                                    roomBooking.DetailsBookingResults
                                      ?.var_HotelName
                                  }
                                </p>
                              </div>
                            </div>
                            <span className="d-block text-gray-1 font-weight-bold mb-2 text-left">
                              Check-In
                            </span>
                            <div className="mb-4">
                              <div className="input-group border-bottom border-width-2 border-color-1 d-flex align-items-baseline">
                                <i className="flaticon-calendar mr-2 text-primary font-weight-semi-bold font-size-22"></i>
                                <p className="w-80">
                                  {formatDate(
                                    roomBooking.DetailsBookingResults
                                      ?.var_HotelCheckIn
                                  )}
                                </p>
                              </div>
                            </div>
                            <span className="d-block text-gray-1 font-weight-bold mb-2 text-left">
                              Check-Out
                            </span>
                            <div className="mb-4">
                              <div className="input-group border-bottom border-width-2 border-color-1 d-flex align-items-baseline">
                                <i className="flaticon-calendar mr-2 text-primary font-weight-semi-bold font-size-22"></i>
                                <p className="w-80">
                                  {formatDate(
                                    roomBooking.DetailsBookingResults
                                      ?.var_HotelCheckOut
                                  )}
                                </p>
                              </div>
                            </div>
                            <span className="d-block text-gray-1 font-weight-bold mb-2 text-left">
                              Number of Rooms:{" "}
                              {roomBooking.DetailsBookingResults?.var_NumRooms}
                            </span>
                            <div className="mb-4">
                              <div className="input-group border-bottom border-width-2 border-color-1 d-flex align-items-baseline">
                                <ul
                                  style={{
                                    listStyle: "none",
                                    paddingLeft: "2px",
                                  }}
                                >
                                  {roomBooking.DetailsBookingResults?.RoomList?.map(
                                    (room, index) => (
                                      <li key={index}>
                                        <i className="flaticon-hotel-bed fs-5 mr-2 text-primary font-weight-bold font-size-40"></i>
                                        {room.var_RoomName} -{" "}
                                        {
                                          roomBooking.DetailsBookingResults
                                            ?.var_RoomBoardName
                                        }
                                        {"  "}
                                      </li>
                                    )
                                  )}
                                </ul>
                              </div>
                            </div>
                            <div>
                              <div className="px-2">
                                <span className="font-size-20">
                                  Total Price :
                                </span>
                                <span className="font-size-24 text-primary font-weight-bold ml-1">
                                  {roomBooking.CurrencyDetails?.CurrencySign}{" "}
                                  {
                                    roomBooking.DetailsBookingResults
                                      ?.GrossAmount
                                  }
                                </span>
                                <span className="font-size-20"> </span>
                              </div>
                            </div>
                          </form>
                        </div>
                      </div>
                    </aside>
                    {/* Hotel Overview */}
                    <div className="rlr-product-detail-section__details col-xl-8">
                      <div
                        className="rlr-secondary-menu-desc mt-0"
                        data-id="rlr-product-sec-overview"
                      >
                        <div className="rlr-secondary-menu-desc__details border-0">
                          <div className="rlr-overview-detail">
                            <div className="rlr-secondary-menu-desc__details">
                              <div className="rlr-overview-detail">
                                <div className="rlr-readmore-desc rlr-overview-detail__description mb-0">
                                  <h4 className="rlr-section__title--main ">
                                    Hotel Overview
                                  </h4>
                                  <div
                                    id="details"
                                    className="rlr-readmore-desc__content rlr-js-desc "
                                    style={{
                                      display: "-webkit-box",
                                      WebkitLineClamp: !showMore && "7",
                                      WebkitBoxOrient: "vertical",
                                      overflow: "hidden",
                                      textOverflow: "ellipsis",
                                    }}
                                    dangerouslySetInnerHTML={{
                                      __html: unescapeHtml(
                                        roomBooking?.DetailsBookingResults
                                          ?.var_HotelDescription
                                      ),
                                    }}
                                  />
                                </div>
                                {roomBooking?.DetailsBookingResults
                                  .var_HotelDescription?.length > 1000 && (
                                  <span
                                    className="rlr-readmore-desc__readmore rlr-js-readmore is-more  "
                                    onClick={() => setShowMore(!showMore)}
                                  >
                                    {showMore ? (
                                      <Link to="#details">Show Less...</Link>
                                    ) : (
                                      "Show more..."
                                    )}
                                  </span>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Leisure Facilities */}
                      <div
                        className="rlr-secondary-menu-desc"
                        data-id="rlr-product-sec-facilities"
                        style={{ marginTop: "0 !important" }}
                      >
                        <div className="rlr-secondary-menu-desc__details">
                          <div className="rlr-readmore-desc">
                            <h4 className="rlr-section__title--main">
                              Most popular facilities
                            </h4>
                          </div>
                          <div className="rlr-facilities-detail">
                            <div className=" rlr-facilities-detail__description">
                              <ul className="mt-3 d-flex justify-content-start flex-wrap gap-4">
                                {roomBooking.List_tbl_Hotels_Features?.map(
                                  (feature) => (
                                    <li
                                      key={feature.FeatureID}
                                      style={{
                                        width: isMobile ? "40%" : "22%",
                                        borderBottom: "0px solid #ccc",
                                      }}
                                    >
                                      {feature.FeatureName}
                                    </li>
                                  )
                                )}
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Cancellation Policy */}
                      <div
                        className="alert alert-danger"
                        style={{ padding: "50px" }}
                      >
                        <h2>Cancellation Policy</h2>
                        <strong>Last Day for Cancelation:</strong>{" "}
                        {formatDate(
                          roomBooking.DetailsBookingResults
                            ?.LastDayForCancelation
                        )}
                        <br />
                        <strong>Cancelation Policy</strong>
                        <span
                          className="d-inline"
                          dangerouslySetInnerHTML={{
                            __html: `${roomBooking.DetailsBookingResults?.CancelationPolicyDescription}`,
                          }}
                        />{" "}
                        <ul>
                          {roomBooking.DetailsBookingResults?.List_cls_booking_cancelpolicy?.map(
                            (item, index) => (
                              <li key={index}>
                                Cancelling from{" "}
                                <b> {formatDate(item.FromDate)}</b> at{" "}
                                {item.FromHour} up to{" "}
                                <b>{formatDate(item.ToDate)}</b>{" "}
                                {`${item.ToHour && `at   ${item.ToHour}`}`} :{" "}
                                {item.DeductionPercent}% of expenses
                              </li>
                            )
                          )}
                        </ul>
                      </div>

                      {/* Booking Form */}
                      <form onSubmit={handleBookingReview}>
                        {/* Add more hidden inputs as needed */}

                        <h2 style={{ margin: "20px 0" }}>Passengers info</h2>
                        <table className="table">
                          <thead>
                            <tr>
                              <th>Adults</th>
                              <th>First Name</th>
                              <th>Last Name</th>
                              <th>Email Address</th>
                              <th>Mobile</th>
                            </tr>
                          </thead>
                          <tbody>
                            {Array.from({ length: totalAdults }, (_, index) => (
                              <tr key={index}>
                                <td>{index + 1}</td>
                                <td>
                                  {isMobile && (
                                    <label
                                      htmlFor={`Adult ${index + 1} First Name`}
                                    >{`Adult ${index + 1} First Name`}</label>
                                  )}
                                  <input
                                    className="form-control"
                                    required
                                    id={`Adult ${index + 1} FirstName`}
                                    type="text"
                                    value={inputValues[index]?.firstName || ""}
                                    onChange={(e) =>
                                      handleInputChange(
                                        index,
                                        "firstName",
                                        e.target.value
                                      )
                                    }
                                  />
                                </td>
                                <td>
                                  {isMobile && (
                                    <label
                                      htmlFor={`Adult ${index + 1} Last Name`}
                                    >{`Adult ${index + 1} Last Name`}</label>
                                  )}
                                  <input
                                    className="form-control"
                                    required
                                    id={`txt_Adult_LastName_${index + 1}`}
                                    type="text"
                                    value={inputValues[index]?.lastName || ""}
                                    onChange={(e) =>
                                      handleInputChange(
                                        index,
                                        "lastName",
                                        e.target.value
                                      )
                                    }
                                  />
                                </td>
                                {index === 0 ? (
                                  <>
                                    <td>
                                      {isMobile && (
                                        <label
                                          htmlFor={`Email_${index + 1}`}
                                        >{`Email`}</label>
                                      )}
                                      <input
                                        className="form-control"
                                        required
                                        id={`Email_${index + 1}`}
                                        type="email"
                                        value={inputValues[index]?.email || ""}
                                        onChange={(e) =>
                                          handleInputChange(
                                            index,
                                            "email",
                                            e.target.value
                                          )
                                        }
                                      />
                                    </td>
                                    <td>
                                      {isMobile && (
                                        <label
                                          htmlFor={`Mobile_${index + 1}`}
                                        >{`Mobile`}</label>
                                      )}
                                      <input
                                        className="form-control"
                                        required
                                        id={`Mobile_${index + 1}`}
                                        type="text"
                                        value={inputValues[index]?.mobile || ""}
                                        onChange={(e) =>
                                          handleInputChange(
                                            index,
                                            "mobile",
                                            e.target.value
                                          )
                                        }
                                      />
                                    </td>
                                  </>
                                ) : (
                                  <>
                                    <td></td>
                                    <td></td>
                                  </>
                                )}
                              </tr>
                            ))}
                          </tbody>
                        </table>
                        {totalChildren > 0 && (
                          <>
                            <h4 style={{ margin: "20px 0" }}>
                              Child Information
                            </h4>
                            <table
                              className={`table ${isMobile ? "w-100" : "w-75"}`}
                            >
                              <thead>
                                <tr>
                                  <td>
                                    <strong>Child</strong>
                                  </td>
                                  <td>
                                    <strong>First Name</strong>
                                  </td>
                                  <td>
                                    <strong>Last Name</strong>
                                  </td>
                                </tr>
                              </thead>
                              <tbody>
                                {Array.from(
                                  { length: totalChildren },
                                  (_, index) => (
                                    <tr key={index}>
                                      <td>{index + 1}</td>
                                      <td>
                                        <input
                                          className="form-control"
                                          required
                                          name={`txt_Adult_FirstName_${index}`}
                                          type="text"
                                          placeholder={`child ${
                                            index + 1
                                          } First Name  `}
                                          value={
                                            childInputValues[index]
                                              ?.firstName || ""
                                          }
                                          onChange={(e) =>
                                            handleChildInputChange(
                                              index,
                                              "firstName",
                                              e.target.value
                                            )
                                          }
                                        />
                                      </td>
                                      <td>
                                        <input
                                          className="form-control"
                                          required
                                          name={`txt_Adult_LastName_${index}`}
                                          type="text"
                                          placeholder={`child ${
                                            index + 1
                                          } Last Name  `}
                                          value={
                                            childInputValues[index]?.lastName ||
                                            ""
                                          }
                                          onChange={(e) =>
                                            handleChildInputChange(
                                              index,
                                              "lastName",
                                              e.target.value
                                            )
                                          }
                                        />
                                      </td>
                                    </tr>
                                  )
                                )}
                              </tbody>
                            </table>
                          </>
                        )}
                        {roomBooking.Extra?.length > 0 && (
                          <div className="my-5">
                            <h2 style={{ margin: "20px 0" }}>
                              Select extras for your stay
                            </h2>
                            {roomBooking.Extra?.map((item) => (
                              <div
                                className="cruises list mb-3"
                                key={item.ExtraId}
                              >
                                <div className="card border-color-7 mb-0 overflow-hidden">
                                  <div className="product-item__outer w-100">
                                    <div className="row">
                                      <article className="rlr-product-card rlr-product-card--v3">
                                        <figure className="rlr-product-card__image-wrapper col-4 h-xl-100">
                                          <div className="swiper rlr-js-product-multi-image-swiper swiper-initialized swiper-horizontal h-xl-100">
                                            <div
                                              className="swiper-wrapper"
                                              style={{
                                                transform:
                                                  "translate3d(0px, 0px, 0px)",
                                                transitionDuration: "0ms",
                                              }}
                                            >
                                              <div
                                                className="swiper-slide h-xl-100"
                                                style={{
                                                  width: "233px",
                                                  marginRight: "30px",
                                                }}
                                              >
                                                <img
                                                  data-sizes="auto"
                                                  data-src={item.ProductPhoto}
                                                  data-srcset={
                                                    item.ProductPhoto
                                                  }
                                                  className="lazyautosizes ls-is-cached lazyloaded h-xl-100"
                                                  alt={`extra ${item.ExtraId}`}
                                                  srcSet={item.ProductPhoto}
                                                  src={item.ProductPhoto}
                                                />
                                              </div>
                                            </div>
                                          </div>
                                        </figure>
                                        <div className="rlr-product-card__detail-wrapper rlr-js-detail-wrapper col-7">
                                          <header className="rlr-product-card__header">
                                            <div className="my-auto">
                                              <Link
                                                className="rlr-product-card__anchor-title"
                                                to="#."
                                              >
                                                <h2 className="rlr-product-card__title">
                                                  {item.ExtraName}
                                                </h2>
                                              </Link>
                                            </div>
                                          </header>
                                          <div className="mt-2 pt-1">
                                            <span className="font-weight-bold font-size-22 ml-1">
                                              {
                                                roomBooking.CurrencyDetails
                                                  ?.CurrencySign
                                              }
                                              {item.PriceRate}{" "}
                                              <small>
                                                ({item.TotalPax} Participant(s))
                                              </small>
                                            </span>
                                          </div>
                                        </div>
                                        <div className="col-2 book-side">
                                          <div className="text-center booking">
                                            <input
                                              id={item.ExtraId}
                                              name={item.ExtraId}
                                              value={item.ExtraId}
                                              checked={checkedValues.includes(
                                                item.ExtraId
                                              )}
                                              onChange={() =>
                                                handleCheckboxChange(
                                                  item.ExtraId
                                                )
                                              }
                                              type="checkbox"
                                              style={{
                                                height: "1.5rem",
                                                cursor: "pointer",
                                              }}
                                              className="form-control"
                                            />
                                            <div className="mt-2 pt-1">
                                              <label
                                                style={{ cursor: "pointer" }}
                                                htmlFor={item.ExtraId}
                                                className="font-weight-bold font-size-22 ml-1"
                                              >
                                                Select
                                              </label>
                                            </div>
                                          </div>
                                        </div>
                                      </article>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            ))}
                          </div>
                        )}
                        <div>
                          <h4 style={{ margin: "20px 0" }}>Remarks</h4>
                          <textarea
                            id="txt_SpecialRequest"
                            className="form-control pt-2"
                            name="txt_SpecialRequest"
                            rows="5"
                            cols="20"
                            style={{ minHeight: "200px" }}
                            value={specialRequest}
                            onChange={(e) => setSpecialRequest(e.target.value)}
                          ></textarea>
                        </div>
                        <button
                          type="submit"
                          className="btn btn-primary btn-lg mt-4"
                        >
                          {loadingReview ? (
                            <>
                              <Spinner
                                as="span"
                                className="pe-2"
                                animation="border"
                                size="sm"
                                role="status"
                                aria-hidden="true"
                              />{" "}
                              Loading...
                            </>
                          ) : (
                            "Continue"
                          )}
                        </button>
                        {typeof reviewBooking === "string" &&
                          reviewBooking.includes("No availability") &&
                          !loadingReview && (
                            <p className="text-danger pt-2">{reviewBooking}</p>
                          )}
                      </form>
                    </div>
                  </div>
                </div>
              </section>
            </>
          )}
        </>
      )}
    </>
  );
};

export default RoomDetails;
